var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgKnownOrigin = function SvgKnownOrigin(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 40 22"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#5165FF",
    d: "M0 21.056h20.712L0 .022zM29.14 21.055c5.757 0 10.423-4.708 10.423-10.516S34.897.023 29.141.023 18.719 4.732 18.719 10.54s4.666 10.516 10.422 10.516"
  })));
};
export default SvgKnownOrigin;